<login-background *letVar="queryParams$ | async as params">
    <ng-container title>
        <a class="cancelLink" routerLink="/login" queryParamsHandling="merge">&lt;Back to Sign In</a>
        <span>Reset your password</span>
    </ng-container>
    <form
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        [formGroup]="form"
        *letVar="isPending$ | async"
        (ngSubmit)="resetPassword()"
    >
        <mat-form-field>
            <input type="email" lowercase-inp matInput placeholder="Email" formControlName="email" />
            <mat-error>
                <app-validation-message
                    [touched]="form.controls.email.touched"
                    [errors]="form.controls.email.errors"
                ></app-validation-message>
            </mat-error>
        </mat-form-field>

        <mat-error *ngIf="errorMessage$ | async as errorMessage">
            {{ errorMessage }}
        </mat-error>

        <button mat-raised-button color="primary" class="login" [disabled]="form.invalid || form.disabled">Email me a reset link</button>

        <p *ngIf="params.staff !== 'false'" class="no-account-help">
            Don't have an account? <a rel="noopener noreferrer" target="_blank" href="https://www.clarecontrols.com/contact">Contact Us</a>
        </p>
    </form>
</login-background>
